
import { WorldCity } from '../types';

// Expansión de Vietnam - 70 ciudades adicionales
export const vietnamAdditionalCities: WorldCity[] = [
  { name: 'Hạ Long', slug: 'ha-long', population: 230000 },
  { name: 'Thái Nguyên', slug: 'thai-nguyen', population: 350000 },
  { name: 'Thanh Hóa', slug: 'thanh-hoa', population: 197185 },
  { name: 'Hưng Yên', slug: 'hung-yen', population: 175153 },
  { name: 'Việt Trì', slug: 'viet-tri', population: 260288 },
  { name: 'Nam Định', slug: 'nam-dinh', population: 231591 },
  { name: 'Bắc Giang', slug: 'bac-giang', population: 126810 },
  { name: 'Bắc Ninh', slug: 'bac-ninh', population: 122169 },
  { name: 'Hòa Bình', slug: 'hoa-binh', population: 105176 },
  { name: 'Hà Giang', slug: 'ha-giang', population: 55559 },
  { name: 'Cao Bằng', slug: 'cao-bang', population: 66560 },
  { name: 'Lạng Sơn', slug: 'lang-son', population: 151991 },
  { name: 'Lào Cai', slug: 'lao-cai', population: 102030 },
  { name: 'Yên Bái', slug: 'yen-bai', population: 78016 },
  { name: 'Điện Biên Phủ', slug: 'dien-bien-phu', population: 70123 },
  { name: 'Lai Châu', slug: 'lai-chau', population: 80500 },
  { name: 'Sơn La', slug: 'son-la', population: 120000 },
  { name: 'Tuyên Quang', slug: 'tuyen-quang', population: 61000 },
  { name: 'Phú Thọ', slug: 'phu-tho', population: 63333 },
  { name: 'Vĩnh Phúc', slug: 'vinh-phuc', population: 48905 },
  { name: 'Bắc Kạn', slug: 'bac-kan', population: 29227 },
  { name: 'Ninh Bình', slug: 'ninh-binh', population: 130517 },
  { name: 'Hà Tĩnh', slug: 'ha-tinh', population: 58577 },
  { name: 'Nghệ An', slug: 'nghe-an', population: 331821 },
  { name: 'Quảng Bình', slug: 'quang-binh', population: 47185 },
  { name: 'Quảng Trị', slug: 'quang-tri', population: 43587 },
  { name: 'Thừa Thiên Huế', slug: 'thua-thien-hue', population: 355968 },
  { name: 'Quảng Nam', slug: 'quang-nam', population: 48716 },
  { name: 'Quảng Ngãi', slug: 'quang-ngai', population: 119251 },
  { name: 'Bình Định', slug: 'binh-dinh', population: 284535 },
  { name: 'Phú Yên', slug: 'phu-yen', population: 103519 },
  { name: 'Khánh Hòa', slug: 'khanh-hoa', population: 404358 },
  { name: 'Ninh Thuận', slug: 'ninh-thuan', population: 59384 },
  { name: 'Bình Thuận', slug: 'binh-thuan', population: 216677 },
  { name: 'Kon Tum', slug: 'kon-tum', population: 53324 },
  { name: 'Gia Lai', slug: 'gia-lai', population: 122260 },
  { name: 'Đắk Lắk', slug: 'dak-lak', population: 211328 },
  { name: 'Đắk Nông', slug: 'dak-nong', population: 58965 },
  { name: 'Lâm Đồng', slug: 'lam-dong', population: 256616 },
  { name: 'Bình Phước', slug: 'binh-phuoc', population: 124407 },
  { name: 'Tây Ninh', slug: 'tay-ninh', population: 166384 },
  { name: 'Bình Dương', slug: 'binh-duong', population: 158777 },
  { name: 'Đồng Nai', slug: 'dong-nai', population: 251066 },
  { name: 'Bà Rịa - Vũng Tàu', slug: 'ba-ria-vung-tau', population: 270224 },
  { name: 'Long An', slug: 'long-an', population: 158780 },
  { name: 'Tiền Giang', slug: 'tien-giang', population: 168372 },
  { name: 'Bến Tre', slug: 'ben-tre', population: 112173 },
  { name: 'Trà Vinh', slug: 'tra-vinh', population: 86122 },
  { name: 'Vĩnh Long', slug: 'vinh-long', population: 147039 },
  { name: 'Đồng Tháp', slug: 'dong-thap', population: 116256 },
  { name: 'An Giang', slug: 'an-giang', population: 157298 },
  { name: 'Kiên Giang', slug: 'kien-giang', population: 179739 },
  { name: 'Cà Mau', slug: 'ca-mau', population: 194970 },
  { name: 'Bạc Liêu', slug: 'bac-lieu', population: 188755 },
  { name: 'Sóc Trăng', slug: 'soc-trang', population: 172213 },
  { name: 'Hậu Giang', slug: 'hau-giang', population: 73595 },
  { name: 'Mỹ Tho', slug: 'my-tho', population: 169365 },
  { name: 'Cao Lãnh', slug: 'cao-lanh', population: 148598 },
  { name: 'Vị Thanh', slug: 'vi-thanh', population: 63320 },
  { name: 'Ngã Bảy', slug: 'nga-bay', population: 47331 },
  { name: 'Châu Đốc', slug: 'chau-doc', population: 157298 },
  { name: 'Hà Tiên', slug: 'ha-tien', population: 49315 },
  { name: 'Rạch Giá', slug: 'rach-gia', population: 179739 },
  { name: 'Phú Quốc', slug: 'phu-quoc', population: 103000 },
  { name: 'Tân An', slug: 'tan-an', population: 158780 },
  { name: 'Gò Công', slug: 'go-cong', population: 62887 },
  { name: 'Cai Lậy', slug: 'cai-lay', population: 54123 },
  { name: 'Sa Đéc', slug: 'sa-dec', population: 87592 },
  { name: 'Tam Kỳ', slug: 'tam-ky', population: 48716 },
  { name: 'Hội An', slug: 'hoi-an', population: 152160 },
  { name: 'Đông Hà', slug: 'dong-ha', population: 43587 },
  { name: 'Đồng Hới', slug: 'dong-hoi', population: 47185 }
];

// Exportar también como expansión completa
export const vietnamExpansion = {
  code: 'VN',
  name: 'Vietnam',
  slug: 'vietnam',
  population: 97340000,
  topCities: [
    { name: 'Ho Chi Minh City', slug: 'ho-chi-minh-city', population: 8993082 },
    { name: 'Hanoi', slug: 'hanoi', population: 4974000 },
    { name: 'Can Tho', slug: 'can-tho', population: 1235171 },
    { name: 'Da Nang', slug: 'da-nang', population: 1007700 },
    { name: 'Bien Hoa', slug: 'bien-hoa', population: 821000 },
    { name: 'Hue', slug: 'hue', population: 455230 },
    { name: 'Nha Trang', slug: 'nha-trang', population: 404358 },
    { name: 'Buon Ma Thuot', slug: 'buon-ma-thuot', population: 340000 },
    { name: 'Vung Tau', slug: 'vung-tau', population: 327000 },
    { name: 'Quy Nhon', slug: 'quy-nhon', population: 284535 },
    ...vietnamAdditionalCities
  ]
};
